export type ListModifierClick = {
  shiftKey: boolean;
  ctrlKey: boolean;
  metaKey: boolean;
};

export function parseSelectedNoteIds(raw: string | null): number[] {
  if (raw == null || raw.trim() === "") return [];
  const seen = new Set<number>();
  const ids: number[] = [];
  for (const part of raw.split(",")) {
    const parsed = Number.parseInt(part.trim(), 10);
    if (!Number.isFinite(parsed) || parsed < 1 || seen.has(parsed)) continue;
    seen.add(parsed);
    ids.push(parsed);
  }
  return ids;
}

export function parseReleaseNoteFilterId(raw: string | null): number | null {
  const ids = parseSelectedNoteIds(raw);
  return ids.length === 1 ? ids[0] : null;
}

export function formatSelectedNoteIds(ids: number[]): string {
  return ids.join(",");
}

export function nextListSelection(options: {
  visibleIds: number[];
  selectedIds: number[];
  clickedId: number;
  anchorId: number | null;
  modifiers: ListModifierClick;
}): { selectedIds: number[]; anchorId: number } {
  const { visibleIds, selectedIds, clickedId, anchorId, modifiers } = options;
  const additive = modifiers.ctrlKey || modifiers.metaKey;
  if (modifiers.shiftKey) {
    const startId = anchorId != null && visibleIds.includes(anchorId) ? anchorId : clickedId;
    const start = visibleIds.indexOf(startId);
    const end = visibleIds.indexOf(clickedId);
    if (start < 0 || end < 0) {
      return { selectedIds: [clickedId], anchorId: clickedId };
    }
    const from = Math.min(start, end);
    const to = Math.max(start, end);
    const range = visibleIds.slice(from, to + 1);
    if (additive) {
      const set = new Set(selectedIds);
      for (const id of range) set.add(id);
      return {
        selectedIds: visibleIds.filter((id) => set.has(id)),
        anchorId: startId,
      };
    }
    return { selectedIds: range, anchorId: startId };
  }
  if (additive) {
    const set = new Set(selectedIds);
    if (set.has(clickedId)) set.delete(clickedId);
    else set.add(clickedId);
    return {
      selectedIds: visibleIds.filter((id) => set.has(id)),
      anchorId: clickedId,
    };
  }
  return { selectedIds: [clickedId], anchorId: clickedId };
}
